import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (date, options = {}) => {
  if (!date) return '';

  const { user, timeZone: explicitTimeZone, includeTime = false } = options;

  // Prioritize user's timezone, then explicit timezone, then default to UTC
  const timeZone = user?.timezone || explicitTimeZone || 'UTC';

  try {
    const formatString = includeTime ? 'M/D/YYYY h:mm A' : 'M/D/YYYY';
    
    // Format the date using the determined timezone
    const formattedDate = dayjs(date).tz(timeZone);
    return formattedDate.format(formatString);
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};
